<template>
  <!-- 这里把原来数字证书授权页面当作组件使用（避免复制） -->
  <div>
    <digital></digital>
  </div>
</template>

<script>
import digital from "../tpl/digital.vue";
export default {
  data() {
    return {};
    // return end
  }, // data end
  components: { digital }
};
</script>

<style></style>



// WEBPACK FOOTER //
// pages/signSettings/digital.vue